import React from 'react';
import './App.css'
function Block({ value, onClick, id, isWinning, winner }) {
    const winningClass = isWinning ? (winner === 'X' ? ' winning-x' : ' winning-o') : '';
    return (
        <div
            className={`block${winningClass}`}
            onClick={onClick}
            id={id}
        >
            {value}
        </div>
    )
}

export default Block;